
import click_drag from "./click_drag";
import drag_timeline from "./drag_timeline";
import export_api from "./export_api";
import fullscreen from "./fullscreen";
import keyboard_navigation from "./keyboard_navigation";
import quick_info from "./quick_info";
import tooltip from "./tooltip";

export default {
	click_drag,
	drag_timeline,
	fullscreen,
	keyboard_navigation,
	quick_info,
	tooltip,
	export_api
};
